'use client'

import { useHouseCoverContext } from '../context'
import ImageCover from './cover'
import MapCover from './map'

export default function CoverContent({
  data
}) {
  const { showMap } = useHouseCoverContext()

  return (
    showMap
      ? <MapCover data={data}></MapCover>
      : <ImageCover data={data}></ImageCover>
  )
}